export default "__VITE_ASSET__Spz_3Jfd__"